<template>
  <div>
    <div class="mui-container-fluid">
        <div id="timer" v-bind:style="{'background-color': bgColor}" v-if="!timeisup">
            <div class="block">
                <p class="digit">
                    <i v-if="isPaused" class="fas fa-spinner fa-1x"></i>
                    <i v-else class="fas fa-spinner fa-1x fa-pulse"></i>
                </p>
            </div>    
            <div class="block">
                <p class="digit">{{ minutes }}</p>
                <p class="text">Minutes</p>
            </div>
            <div class="block">
                <p class="digit">:</p>
                <p class="text">&nbsp</p>
            </div>    
            <div class="block">
                <p class="digit">{{ seconds }}</p>
                <p class="text">Seconds</p>
            </div>
        </div>
            <div class="controls">
                <div v-if="!timeisup">
                    <button v-if="isPaused" class="mui-btn mui-btn--raised mui-btn--primary" v-on:click="restartTimer"><i class="fas fa-play"></i>&nbsp; Restart</button>
                    <button v-else class="mui-btn mui-btn--raised mui-btn--primary" v-on:click="pauseTimer"><i class="fas fa-pause"></i>&nbsp; Pause</button>
                    <button v-if="isSoundOff" class="mui-btn mui-btn--raised mui-btn--primary" v-on:click="switchSound"><i class="fas fa-volume-up"></i>&nbsp; Play sound</button>
                    <button v-else class="mui-btn mui-btn--raised mui-btn--primary" v-on:click="switchSound"><i class="fas fa-volume-off"></i>&nbsp; Mute</button>
                </div>
            </div>
        <div class="timeisup" v-bind:style="{'background-color': bgColor}" v-if="timeisup" >
            <div class="mui-col-12">
                <i class="fas fa-hourglass-end fa-2x"></i>
                Time is up!
                <div class="mui-col-12">
                    <router-link to="/" tag="button" class="mui-btn mui-btn--raised mui-btn--primary button"><i class="fas fa-step-backward"></i>&nbsp;Start another</router-link>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NaTimer',
  mounted: function () {
    this.timerId = window.setInterval( () => {
        this.now = Math.trunc((new Date()).getTime() / 1000);
    }, 1000);
  },
  props: {
      minutesToRun: {
          type: Number,
          coerce: str => Math.trunc(Date.parse(str) / 1000)
      },
  },
  data () {
    return {
        now: Math.trunc((new Date()).getTime() / 1000),
        timeEnd: Math.trunc((new Date()).getTime() / 1000) + this.minutesToRun*60,
        timerId: null,
        tminutes: null,
        tseconds: null,
        timeisup: false,
        isPaused: false,
        isSoundOff: true,
        sound: null
    }
  },
  methods: {
      pauseTimer(){
        clearInterval(this.timerId);
        this.isPaused = true;
      },
      restartTimer(){
        this.timeEnd = Math.trunc((new Date()).getTime() / 1000) + this.tminutes*60 + this.tseconds,
        this.now = Math.trunc((new Date()).getTime() / 1000);
        this.timerId = window.setInterval( () => {
        this.now = Math.trunc((new Date()).getTime() / 1000);
    }, 1000);
        this.isPaused = false;
      },
      switchSound(){
          if (this.isSoundOff) {
              this.isSoundOff = false;
              this.sound = new Audio('/static/sounds/Train-Horn-Low.mp3');
          } else {
              this.isSoundOff = true;
          }
      }
  },
  computed: {
    minutes() {
        this.tminutes = Math.trunc((this.timeEnd - this.now) / 60) % 60;
        return this.tminutes;
    },

    seconds() {
        this.tseconds = (this.timeEnd - this.now) % 60;
        if (this.tminutes === 0 && this.tseconds === 0) {
            clearInterval(this.timerId);
            this.timeisup = true;
            if (!this.isSoundOff){
                this.sound.play();
            }
        } 
        return this.tseconds;
    },

    bgColor() {
        let color = "#34495e";
        if (this.minutes < 1) {
            if (this.seconds < 20) {
                color = "#631818";
            } else {
                color = "#BB5C24";
            }
        }
        return color;
    }
  }
}
</script>

<style>
@import url(https://fonts.googleapis.com/css?family=Roboto+Condensed:400|Roboto:100,400,700);

#timer {
    align-items: center;
    justify-content: center;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #34495e;
    display: flex;
}

.block {
    display: flex;
    flex-direction: column;
    margin: 20px;
}

.text {
    color: #1abc9c;
    font-size: 40px;
    font-family: 'Roboto Condensed', serif;
    font-weight: 40;
    margin-top:10px;
    margin-bottom: 10px;
    text-align: center;
}

.digit {
    color: #ecf0f1;
    font-size: 150px;
    font-weight: 700;
    font-family: 'Roboto', serif;
    margin: 10px;
    text-align: center;
}

.timeisup {
    color: #ecf0f1;
    font-size: 150px;
    font-weight: 700;
    font-family: 'Roboto', serif;
    margin: 0px;
    text-align: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    align-items: center;
    justify-content: center;
    display: flex;
}

.controls {
    color: #ecf0f1;
    text-align: center;
    top: 450px;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    align-items: center;
    justify-content: center;
    display: flex;
}


.button {
    color: #ffffff;
}



@media all and (max-width: 629px){

  .timeisup {
    font-size: 50px;
  }

}

@media all and (max-width: 730px){

    .text {
        font-size: 20px;
    }

    .digit {
        font-size: 100px;
    }

}


@media all and (max-width: 500px){

    .block {
        margin: 10px;
    }

    .digit {
        margin: 5px;
    }

}



</style>



// WEBPACK FOOTER //
// src/components/Timer.vue